import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { CustomSVGProps, getBaseSVGProps } from './utils';

const ProceduresFilled: React.FC<CustomSVGProps> = (props) => {
    return (
        <Svg {...getBaseSVGProps(props, 16)} fill="none">
            <Path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5 2C3.34315 2 2 3.34315 2 5V11C2 12.6569 3.34315 14 5 14H11C12.6569 14 14 12.6569 14 11V5C14 3.34315 12.6569 2 11 2H5ZM6.87266 5H9.12266V6.87734H11V9.12734H9.12266V11H6.87266V9.12734H5V6.87734H6.87266V5Z"
                fill={props.color}
            />
        </Svg>
    );
};

export default React.memo(ProceduresFilled);
